import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Button, Form } from "react-bootstrap";
import { usePaymentMethod } from "contexts/v1/masterData/PaymentMethodContext";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { IconMinus, IconPlus, IconTrash } from "@tabler/icons-react";

const TransactionForm = ({
  initialData = null,
  mode = "create", // or 'edit'
  onSuccess,
  setCart,
  cartItems,
    onError,
}) => {
//   const [cart, setCart] = useState([]);
  const cart = cartItems;
  const [cashPaid, setCashPaid] = useState("");
  const [change, setChange] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [formData, setFormData] = useState({
    payment_method_id: "",
    notes: "",
  });

  const { paymentMethods } = usePaymentMethod();

  const { createData } = useCreateData("/transaction", "transactions");
  const { updateData } = useUpdateData(
    `/transaction/${initialData?.id}`,
    "transactions"
  );

  const [taxRate, setTaxRate] = useState(0);

  useEffect(() => {
    if (!paymentMethod) {
      setTaxRate(0);
      return;
    }
    const selectedMethod = paymentMethods?.data?.find(
      (pm) => pm.name === paymentMethod
    );
    if (selectedMethod) {
      const rawTax = parseFloat(selectedMethod.tax);
      const taxDecimal = rawTax / 100;
      setTaxRate(isNaN(taxDecimal) ? 0 : taxDecimal);
    } else {
      setTaxRate(0);
    }
  }, [paymentMethod, paymentMethods]);

  const subtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const productTaxAmount = cart.reduce((sum, item) => {
    const itemTax = (parseFloat(item.tax_percent) || 0) / 100;
    return sum + (item.price * item.quantity * itemTax);
  }, 0);

  const paymentTaxAmount = (subtotal + productTaxAmount) * taxRate;
  const grandTotal = subtotal + productTaxAmount + paymentTaxAmount;

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setFormData({
        payment_method_id: initialData.payment_method_id,
        notes: initialData.notes || "",
      });

      setCart(
        initialData.transaction_items.map((item) => ({
          id: item.menu_id,
          name: item.item_name,
          price: parseFloat(item.price),
          quantity: item.quantity,
        }))
      );

      setPaymentMethod(initialData.payment_method?.name || "");
    }
  }, [initialData, mode]);

  useEffect(() => {
    if (paymentMethod === "Cash") {
      const cash = parseInt(cashPaid, 10) || 0;
      setChange(cash - grandTotal);
    }
  }, [cashPaid, grandTotal, paymentMethod]);

  const handleSubmit = async () => {
    const method = paymentMethods.data.find((p) => p.name === paymentMethod);

    if (!method)
      return Swal.fire("Error", "Metode pembayaran tidak valid", "error");

    const payload = {
      payment_method_id: method.id,
      notes: formData.notes,
      total_price: subtotal.toString(),
      tax: (productTaxAmount + paymentTaxAmount).toString(),
      grand_total: grandTotal.toString(),
      tax_percent: (subtotal > 0 ? ((productTaxAmount + paymentTaxAmount) / subtotal * 100).toFixed(1) : "0"),
      items: cart.map((item) => {
        const itemTaxPercent = parseFloat(item.tax_percent || 0);
        const itemTaxAmount = (item.price * item.quantity * itemTaxPercent) / 100;
        return {
          menu_id: item.id,
          item_name: item.name,
          price: item.price.toString(),
          quantity: item.quantity.toString(),
          tax_percent: itemTaxPercent.toString(),
          tax_amount: itemTaxAmount.toString(),
        };
      }),
    };

    try {
      if (mode === "edit") {
        await updateData(payload);
      } else {
        await createData(payload);
      }

      Swal.fire("Success", "Transaksi berhasil disimpan", "success");
      onSuccess();
    } catch (error) {
      Swal.fire("Error", "Gagal menyimpan transaksi", "error");
      onError(error);
    }
  };

  const adjustQuantity = (itemId, amount) => {
    setCart((prev) =>
      prev
        .map((item) =>
          item.id === itemId
            ? { ...item, quantity: item.quantity + amount }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  const removeItem = (itemId) => {
    setCart((prev) => prev.filter((item) => item.id !== itemId));
  };
  

  return (
    <div className="p-3">
      {/* Render daftar item */}
      <h4>Items</h4>
      {/* <ul>
        {cart.map((item) => (
          <li key={item.id}>
            {item.name} x{item.quantity} - Rp {item.price.toLocaleString()}
          </li>
        ))}
      </ul> */}

      <table className="table table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Menu</th>
            <th>Qty</th>
            {/* <th>Harga</th> */}
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {cart.map((item) => (
            <tr key={item.id}>
                <td>{cart.indexOf(item) + 1}</td>
              <td>{item.name}</td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <Button
                    className="btn-sm btn-icon btn-outline-danger"
                    onClick={() => adjustQuantity(item.id, -1)}
                  >
                    <IconMinus size={16} />
                  </Button>
                  <span>{item.quantity}</span>
                  <Button
                    className="btn-sm btn-icon btn-outline-info"
                    onClick={() => adjustQuantity(item.id, 1)}
                  >
                    <IconPlus size={16} />
                  </Button>
                </div>
              </td>
              {/* <td>Rp {item.price.toLocaleString()}</td> */}
              <td>Rp {(item.price * item.quantity).toLocaleString()}</td>
              <td>
                <Button
                className="btn-sm btn-icon btn-outline-danger"
                  onClick={() => removeItem(item.id)}
                >
                  <IconTrash size={16} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mb-3">
        <div className="d-flex justify-content-between">
          <span>Subtotal:</span>
          <span>Rp {subtotal.toLocaleString()}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>ppn/tax:</span>
          <span>Rp {productTaxAmount.toLocaleString()}</span>
        </div>
        {paymentTaxAmount > 0 && (
          <div className="d-flex justify-content-between">
            <span>{paymentMethod.toLowerCase()} {taxRate * 100}% :</span>
            <span>Rp {paymentTaxAmount.toLocaleString()}</span>
          </div>
        )}
        <h4 className="d-flex justify-content-between mt-2">
          <span>Grand Total:</span>
          <span>Rp {grandTotal.toLocaleString()}</span>
        </h4>
      </div>

      <Form.Group>
        <Form.Label>Metode Pembayaran</Form.Label>
        <div className="d-flex flex-wrap gap-2">
          {paymentMethods.data.map((method) => (
            <Button
              key={method.id}
              variant={
                paymentMethod === method.name ? "success" : "outline-success"
              }
              onClick={() => setPaymentMethod(method.name)}
            >
              {method.name}
            </Button>
          ))}
        </div>
      </Form.Group>

      {paymentMethod === "Cash" && (
        <Form.Group className="mt-2">
          <Form.Label>Uang Dibayar</Form.Label>
          <Form.Control
            type="number"
            value={cashPaid}
            onChange={(e) => setCashPaid(e.target.value)}
          />
          {cashPaid && (
            <div className="mt-2">
              {change < 0 ? (
                <span className="text-danger">
                  Kurang Rp {Math.abs(change).toLocaleString()}
                </span>
              ) : (
                <span className="text-success">
                  Kembalian Rp {change.toLocaleString()}
                </span>
              )}
            </div>
          )}
        </Form.Group>
      )}

      <Form.Group className="mt-2">
        <Form.Label>Catatan</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={formData.notes}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, notes: e.target.value }))
          }
        />
      </Form.Group>

      <Button className="mt-3" onClick={handleSubmit}>
        {mode === "edit" ? "Update Transaksi" : "Simpan Transaksi"}
      </Button>
    </div>
  );
};

export default TransactionForm;
